import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import Image from 'gatsby-image';

import Layout from '../components/layout';
import SEO from '../components/seo';

const IndexPage = () => {
  const query = useStaticQuery(graphql`
    query {
      truck: file(relativePath: { eq: "truck.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 600, maxHeight: 450) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      truckSp: file(relativePath: { eq: "truck.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 375) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      oven: file(relativePath: { eq: "oven.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 600, maxHeight: 450) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      ovenSp: file(relativePath: { eq: "oven.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 375) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      festival: file(relativePath: { eq: "festival.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 400, maxHeight: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      festivalSp: file(relativePath: { eq: "festival.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 375) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      housing: file(relativePath: { eq: "housing.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 400, maxHeight: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      housingSp: file(relativePath: { eq: "housing.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 375) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      localFestival: file(relativePath: { eq: "local-festival.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 400, maxHeight: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      localFestivalSp: file(relativePath: { eq: "local-festival.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 375) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      shavedIce: file(relativePath: { eq: "shaved-ice.jpeg" }) {
        childImageSharp {
          fluid(maxWidth: 300, maxHeight: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      shavedIceSp: file(relativePath: { eq: "shaved-ice.jpeg" }) {
        childImageSharp {
          fluid(maxWidth: 375) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      friedPotato: file(relativePath: { eq: "fried-potato.jpeg" }) {
        childImageSharp {
          fluid(maxWidth: 300, maxHeight: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      friedPotatoSp: file(relativePath: { eq: "fried-potato.jpeg" }) {
        childImageSharp {
          fluid(maxWidth: 375) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      bananaJuice: file(relativePath: { eq: "banana-juice.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 300, maxHeight: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      bananaJuiceSp: file(relativePath: { eq: "banana-juice.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 375) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      customizable: file(relativePath: { eq: "customizable.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 300, maxHeight: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      customizableSp: file(relativePath: { eq: "customizable.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 375) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      hero: file(relativePath: { eq: "hero.png" }) {
        childImageSharp {
          fluid(maxWidth: 600, maxHeight: 350) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      heroSp: file(relativePath: { eq: "hero.png" }) {
        childImageSharp {
          fluid(maxWidth: 375) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);

  const ContactButton = () => (
    <a
      href="https://forms.gle/vZfmAQW6qfVQcagdA"
      className="mx-auto lg:mx-0 hover:underline bg-red-400 text-white font-bold rounded-full my-6 py-4 px-8 shadow-lg"
    >
      ご依頼・お問い合わせ
    </a>
  );

  const AboutUs = () => {
    const sources = [
      query.truckSp.childImageSharp.fluid,
      {
        ...query.truck.childImageSharp.fluid,
        media: `(min-width: 768px)`,
      },
    ];

    return (
      <section>
        <div className="container mx-auto pt-24 px-3 flex flex-wrap flex-col md:flex-row items-center justify-center">
          {/* Left Col */}
          <div className="flex flex-col w-full md:w-2/5 justify-center items-start text-center md:text-left">
            <h1 className="my-4 text-5xl font-bold leading-tight">
              東京都近郊で活動しているキッチンカーです
            </h1>
            <p className="leading-normal text-2xl mb-8">
              千葉県、神奈川、埼玉県にも出店しています。その他地域にも要相談になりますが出店可能です。
              ランチ出店、イベント出店、出張出店等幅広く対応しています。
            </p>
            <ContactButton />
          </div>

          {/* Right Col */}
          <div className="w-full md:w-3/5 py-6 text-center">
            <div className="w-full md:w-4/5 mx-auto z-50">
              <Image fluid={sources} alt="フードトラック" />
            </div>
          </div>
        </div>
      </section>
    );
  };

  const AboutOven = () => {
    const sources = [
      query.ovenSp.childImageSharp.fluid,
      {
        ...query.oven.childImageSharp.fluid,
        media: `(min-width: 768px)`,
      },
    ];

    return (
      <section>
        <div className="container mx-auto pt-8 px-3 flex flex-wrap flex-col-reverse md:flex-row items-center">
          {/* Left Col */}
          <div className="w-full md:w-3/5 py-6 text-center">
            <div className="w-full md:w-4/5 mx-auto z-50">
              <Image fluid={sources} className="rounded-lg" alt="業務用スチームコンベクションオーブン" />
            </div>
          </div>

          {/* Right Col */}
          <div className="flex flex-col w-full md:w-2/5 justify-center items-start text-center md:text-left">
            <h1 className="my-4 text-5xl font-bold leading-tight">
              業務用スチームコンベクションオーブンを搭載
            </h1>
            <p className="leading-normal text-2xl mb-8">
              大量調理が可能なスチコンを搭載しているので、「焼く」「蒸す」「煮る」「茹でる」「炒める」「炊く」といった調理が行えます。数百人規模のイベントでも余裕を持って対応できます。
            </p>
          </div>
        </div>
      </section>
    );
  };

  const ListOfSellingStyle = () => {
    const sources = {
      festival: [
        query.festivalSp.childImageSharp.fluid,
        {
          ...query.festival.childImageSharp.fluid,
          media: `(min-width: 768px)`,
        },
      ],
      housing: [
        query.housingSp.childImageSharp.fluid,
        {
          ...query.housing.childImageSharp.fluid,
          media: `(min-width: 768px)`,
        },
      ],
      localFestival: [
        query.localFestivalSp.childImageSharp.fluid,
        {
          ...query.localFestival.childImageSharp.fluid,
          media: `(min-width: 768px)`,
        },
      ],
    };

    const SellingStyle = ({ name, appealPoint, description, image, altText }) => (
      <div className="w-full md:w-1/3 p-6 flex flex-col flex-grow flex-shrink">
        <div className="flex-1 bg-white rounded-t rounded-b-none overflow-hidden shadow-lg">
          <div className="w-full">
            <Image fluid={image} alt={altText} />
          </div>
          <p className="w-full text-gray-600 text-xs md:text-sm px-6">
            {appealPoint}
          </p>
          <div className="w-full font-bold text-xl text-gray-800 px-6">
            {name}
          </div>
          <p className="text-gray-800 text-base px-6 mb-5">{description}</p>
        </div>
      </div>
    );

    return (
      <section className="bg-white border-b py-8">
        <div className="container mx-auto flex flex-wrap pt-4 pb-12">
          <h1 className="w-full my-2 text-5xl font-bold leading-tight text-center text-gray-800">
            出店方式
          </h1>
          <div className="w-full mb-4">
            <div className="h-1 mx-auto bg-red-400 w-64 opacity-25 my-0 py-0 rounded-t" />
          </div>
          <SellingStyle
            name="通常出店"
            appealPoint="大規模イベント等大勢の集客が見込める場合にオススメ!!"
            description="来場数1000人以上を見込めるような大規模イベント、商業施設向けの出店方法です。当店からお客様に直接販売する形となりご依頼者様の費用負担はございません(保健所の営業許可申請、その他必要な設備等によっては別途経費がかかる場合があります)。音楽フェス、スポーツイベント、お祭りなどに最適な出店方法です。"
            image={sources.festival}
            altText="音楽フェス"
          />
          <SellingStyle
            name="買い取り出店"
            appealPoint="お客様へ還元・サービスを提供して集客アップに!!"
            description="予め提供数と値段を決めて、すべて買取を行っていただく条件での出店方法です。まとまった数の提供を行う場合には通常の販売価格よりもお安く提供することも検討可能です。来場者数が予め見込めている場合や提供単価をなるべく下げたい場合にオススメです。住宅展示場、家電量販店でのお客様への還元・サービスとしての利用や企業様での懇親イベント、パーティーにいかがでしょうか？"
            image={sources.housing}
            altText="住宅展示場"
          />
          <SellingStyle
            name="売上保証型"
            appealPoint="出店依頼をしたいけど、出費をできるだけ抑えたい!!"
            description="1日の最低売上金額を決めた上で、お客様に商品を販売いたします。当日の売上が設定金額よりも少ない場合のみ、不足分を依頼者様にお支払いいただきます。集客予想が難しい場合や想定よりも集客が少ない場合にも極力費用を抑えて出店依頼を行うことができます。地域のお祭りや中規模程度のイベントなどにオススメです。"
            image={sources.localFestival}
            altText="町内のお祭り"
          />
        </div>
        <div className="flex items-center justify-center">
          <ContactButton />
        </div>
      </section>
    );
  };

  const MenuSection = () => {
    const sources = {
      shavedIce: [
        query.shavedIceSp.childImageSharp.fluid,
        {
          ...query.shavedIce.childImageSharp.fluid,
          media: `(min-width: 768px)`,
        },
      ],
      friedPotato: [
        query.friedPotatoSp.childImageSharp.fluid,
        {
          ...query.friedPotato.childImageSharp.fluid,
          media: `(min-width: 768px)`,
        },
      ],
      bananaJuice: [
        query.bananaJuiceSp.childImageSharp.fluid,
        {
          ...query.bananaJuice.childImageSharp.fluid,
          media: `(min-width: 768px)`,
        },
      ],
      customizable: [
        query.customizableSp.childImageSharp.fluid,
        {
          ...query.customizable.childImageSharp.fluid,
          media: `(min-width: 768px)`,
        },
      ],
    };

    const MenuItem = ({ name, image, altText }) => {
      return (
        <div className="rounded overflow-hidden shadow">
          <Image fluid={image} alt={altText} />
          <div className="px-6 py-2">
            <div className="font-bold text-xl text-center mb-2">{name}</div>
          </div>
        </div>
      );
    };

    return (
      <section className="bg-white border-b py-8">
        <div className="container mx-auto flex flex-wrap pt-4 pb-12">
          <h1 className="w-full my-2 text-5xl font-bold leading-tight text-center text-gray-800">
            MENU
          </h1>
          <div className="w-full mb-4">
            <div className="h-1 mx-auto bg-red-400 w-64 opacity-25 my-0 py-0 rounded-t" />
          </div>
          <div className="px-4">
            メニューは季節、販売場所によって随時変更しています。
            <br />
            お手軽なスナック系から煮込み料理、グリルなどの本格的な料理とデザート、ドリンク等取り揃えております。
          </div>
          <div className="w-full mx-auto grid grid-cols-2 md:grid-cols-4 gap-2 p-4">
            <MenuItem name="かき氷" image={sources.shavedIce} altText="かき氷" />
            <MenuItem name="フライドポテト" image={sources.friedPotato} altText="フライドポテト" />
            <MenuItem name="バナナジュース" image={sources.bananaJuice} altText="バナナジュース" />
            <MenuItem
              name="随時追加中、個別対応も可能です"
              image={sources.customizable}
              altText="個別対応"
            />
          </div>
        </div>
      </section>
    );
  };

  const Closing = () => {
    const sources = [
      query.heroSp.childImageSharp.fluid,
      {
        ...query.hero.childImageSharp.fluid,
        media: `(min-width: 768px)`,
      },
    ];

    return (
      <section className="bg-white border-b py-8">
        <div className="container mx-auto pt-8 px-3 flex flex-wrap flex-col md:flex-row items-center">
          {/* Left Col */}
          <div className="flex flex-col w-full md:w-2/5 justify-center items-start text-center md:text-left">
            <h1 className="my-4 text-5xl font-bold leading-tight">
              あなたのイベント、お店にキッチンカーを呼びませんか?
            </h1>
            <p className="leading-normal text-2xl mb-8">
              まずはお気軽にご連絡ください。メニューや金額等おおまかなお見積りを作成いたします。
              <br />
              E-Mail: contact@nullfull.co.jp
              <br />
              Tel: 050-5375-2062
            </p>
            <ContactButton />
          </div>

          {/* Right Col */}
          <div className="w-full md:w-3/5 py-6 text-center">
            <div className="w-full md:w-4/5 mx-auto z-50">
              <Image fluid={sources} className="rounded-lg" alt="キッチンカー出店イラスト" />
            </div>
          </div>
        </div>
      </section>
    );
  };

  return (
    <Layout>
      <SEO title="Home" />
      <AboutUs />
      <AboutOven />
      <ListOfSellingStyle />
      <MenuSection />
      <Closing />
      <section className="bg-white border-b py-8">
        <div className="container mx-auto pt-8 px-3">
          <h1 className="w-full my-2 text-5xl font-bold leading-tight text-center text-gray-800">
            出店予定カレンダー
          </h1>
          <div className="w-full mb-4">
            <div className="h-1 mx-auto bg-red-400 w-64 opacity-25 my-0 py-0 rounded-t" />
          </div>
          <div className="w-full mt-4 flex justify-center">
            <iframe
              src="https://calendar.google.com/calendar/embed?src=nullfull.co.jp_0vndk3fi20ir0ljlhtdh7if648%40group.calendar.google.com&ctz=Asia%2FTokyo"
              title="出店予定カレンダー"
              style={{ border: 0 }}
              width="800"
              height="600"
              frameBorder="0"
              scrolling="no"
            />
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default IndexPage;
